import React, { useContext } from 'react';
import Modal from '@mui/material/Modal';
import { Icons } from '@Assets/SvgIcons';
import logo from '@Assets/images/loader.gif';
import { TemplateLibraryContext, TemplateLibraryContextType } from '../TemplateLibrary/TemplateLibrary.context';
import TemplateLibraryTabs from '../TemplateLibraryTabs/TemplateLibraryTabs.component';
import TemplateLibraryModalFooter from '../TemplateLibraryModalFooter/TemplateLibraryModalFooter.component';
import './TemplateLibraryModal.component.scss';


export interface TemplateLibraryModalProps {
  open: boolean;
  handleClose: () => void;
};

const TemplateLibraryModal = ({
  open,
  handleClose
}: TemplateLibraryModalProps) => {
  const { 
    loading,
  } = useContext(TemplateLibraryContext) as TemplateLibraryContextType;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      {!loading ? (
        <div className="template-library-modal" data-testid="template-library-modal">
          <div className="template-library-modal__header">
            <div className="template-library-modal__header__title">
              Mergeflo Templates
            </div>
            <button
              className="template-library-modal__header__close-button"
              onClick={handleClose}
            >
              <Icons.Cancel />
            </button>
          </div>
          <div className="template-library-modal__content">
            <TemplateLibraryTabs />
          </div>
          <TemplateLibraryModalFooter />
        </div>
      ) : (
        <div id="overlay">
          <img src={logo} alt="Be patient..." />
        </div>
      )}
    </Modal>
  )
}

export default TemplateLibraryModal;
